@use '@design/design-tokens/border-radius/border-radius' as *;

@layer chart {
  .legendMoreMenuRoot {
    display: flex;
    position: relative;
    height: 20px;
    width: 20px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    &:hover {
      background-color: var(--surface-hover);
    }
  }

  .menuIcon {
    transform: rotate(90deg);
    cursor: pointer;
  }

  .iconWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .colorPicker {
    padding: 8px;
    background-color: var(--surface-default);
    outline: 1px solid var(--border-soft);
    @include border-radius-r1;
    display: flex;
    flex-wrap: wrap;
    position: fixed;
    width: 170px;
    gap: 8px;
  }

  .leftIcon {
    fill: currentColor;
  }

  .smallColorIcon {
    @include border-radius-full;
    width: 16px;
    height: 16px;
  }

  .colorIcon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    @include border-radius-full;

    svg {
      fill: var(--icon-on-primary);
    }

    &.selected {
      border: 2px solid black;
      outline: 1px solid var(--color-icon-color);
    }

    &:hover {
      cursor: pointer;
      border: 2px solid black;
      outline: 1px solid var(--color-icon-color);
    }
  }
}
